
export default "/assets/credit-card-mini.dd99eba6.svg"